import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView, ListSection, ListItem } from 'medua-components';

/* eslint-disable */
@translate(['account'])
export default class AccountLegal extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:legal.title') }>
        <ListSection margin>
          <ListItem
            key="1"
            title={ this.props.t('account:legal.license.title') }
            url="/account/legal/license" />
          <ListItem
            key="2"
            title={ this.props.t('account:legal.tos.title') }
            url="/account/legal/tos" />
        </ListSection>
        </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/legal/index.jsx